import { API } from 'aws-amplify';

import {
  BookingPlatformSupplier,
  BookingPlatfromActivities,
  FranchiseVendor,
  SignupVendorPayload,
  Vendor,
} from '../types/Vendor';
import type { Tier } from '../schemas/VendorSchema';

import type { User } from './UsersAPI';

export async function fetchVendorsList(searchQuery: string) {
  return API.get('party', '/vendors', {
    queryStringParameters: {
      q: JSON.stringify({
        limit: 100,
        filter: {
          name: {
            match: searchQuery,
          },
        },
      }),
    },
  });
}

export async function fetchVendorById(id): Promise<Vendor> {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/booking-vendors/${id}`);
}

export async function updateVendor(vendor) {
  const { type, id } = vendor;
  return API.patch('party', `/vendors/${type}/${id}`, { body: vendor });
}

export async function getStripeConnectedAccounts() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/stripe/connected-accounts');
}

export async function getFareHarborCompanies() {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', '/fareharbor/companies');
}

export async function associateStripeAccountWithFareharborCompany(
  selectedStripeAccountId,
  companyToAssociateWith
) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.put(
    'party',
    `/fareharbor/company/${companyToAssociateWith}/connect/${selectedStripeAccountId}`
  );
}

export function getSuppliers(
  bookingPlatformType: string
): Promise<BookingPlatformSupplier[]> {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/suppliers/${bookingPlatformType}`);
}

export function getBookingPlatformActivities(
  vendorId: string
): Promise<BookingPlatfromActivities[]> {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/booking-vendors/${vendorId}/items`);
}

export async function updateBookingVendor(vendor: Vendor): Promise<Vendor> {
  const { id } = vendor;
  return API.patch('party', `/booking-vendors/${id}`, { body: vendor });
}

export async function signupVendor(payload: SignupVendorPayload) {
  return API.post('party', `/users/signup-vendor`, {
    body: payload,
  });
}

export async function getVendorAssociatedUsers(
  vendorId: string
): Promise<User['Item'][]> {
  return API.get('party', `/portal-vendors/${vendorId}/associated-users`, {});
}

export function getActivityFromBookingPlatform(
  vendorId: string,
  itemId: string,
  bookingPlatformType: string
) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get(
    'party',
    `/booking-vendors/${vendorId}/items/${itemId}/build-activity/${bookingPlatformType}`
  );
}

export function getPricingTables(): Promise<Tier[]> {
  return API.get('party', '/pricing-tables', {});
}

export function getFranchiseVendors(): Promise<FranchiseVendor[]> {
  return API.get('party', '/portal-vendors/franchises', {});
}
